module.exports = __webpack_public_path__ + "img/about2.8a340db3.png";